import { Resume } from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import Divider from '../common/Divider';
import { Box, Image, ResumeHeading, Text, WebsiteLink } from '../common/ui';

const Header = ({ resume }: { resume: Resume }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const {
    city,
    email,
    firstName,
    lastName,
    phone,
    state,
    summary,
    title,
    website,
    website2,
  } = resume.about;
  const location = (city || state) && (
    <Divider divider=", ">
      {city}
      {state}
    </Divider>
  );
  return (
    <>
      <Box as="header" variant="headerContainer" className="pdf-resume-header">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
            mb: calcSize(1.25),
          }}
        >
          <ResumeHeading mt={resume.profilePhotoUrl ? calcSize(0.625) : 0}>
            {firstName}
            <br />
            {lastName}
          </ResumeHeading>
          {resume.profilePhotoUrl && (
            <Box
              sx={{
                width: [64, 128],
                flexGrow: 0,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                position: ['absolute', 'relative'],
                top: [0, 'auto'],
                right: [16, 'auto'],
              }}
            >
              <Image
                src={resume.profilePhotoUrl}
                sx={{
                  borderRadius: 999,
                  height: [64, 128],
                  width: [64, 128],
                  objectFit: 'cover',
                }}
              />
            </Box>
          )}
        </Box>
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          {summary && <Text variant="resumeSummary">{summary}</Text>}
          <Text
            sx={{
              fontSize: 0,
              color: 'text2',
            }}
          >
            <Divider divider=" | ">
              {title}
              {location}
              {email}
              {phone}
              {website && <WebsiteLink url={website} />}
              {website2 && <WebsiteLink url={website2} />}
            </Divider>
          </Text>
        </Box>
      </Box>
    </>
  );
};

export default Header;
